export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">关于被窝影院</h2>
          <div className="w-16 h-1 bg-accent-500 mx-auto mb-6 rounded-full"></div>
          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              被窝影院诞生于对电影的热爱。我们致力于打造一个纯净、流畅、内容丰富的免费电影平台，
              让每一位影迷都能轻松找到自己想看的影片。没有烦人的弹窗广告，没有复杂的注册流程，
              打开网站就能直接观影——这就是我们一直坚持的理念。
            </p>
            <p>
              平台涵盖动作、喜剧、悬疑、科幻、动画、纪录片等全品类内容，从最新院线下线影片到
              高分经典老片，从国产佳作到海外巨制，持续更新、持续优化。被窝影院团队每天精选优质
              资源，确保片源高清、播放流畅，让你窝在被窝里就能畅享电影院级别的观影体验。
            </p>
            <p>
              上线以来，我们已经服务了超过百万影迷，累计提供数万部电影资源。未来我们将继续
              扩展内容库，优化播放体验，做你身边最贴心的在线电影伴侣。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
            {[
              { num: '100万+', label: '累计影迷' },
              { num: '28,000+', label: '影视资源' },
              { num: '99.7%', label: '无广告率' },
              { num: '365天', label: '全年更新' },
            ].map((stat, i) => (
              <div key={i} className="p-4 rounded-xl bg-background-50 border border-background-200/70">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">{stat.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}